// extracted by mini-css-extract-plugin
export default {"fade":"EC+t8","show":"Ax421","collapse":"TPz2n","collapsing":"QjEUt","width":"yTOUY","collapsing-horizontal":"y3K4d","collapse-only-mobile":"Xwp-J","collapse-only-desktop":"UqV85"};